// section-product-row.js — Best Sellers horizontal slider
// Uses native smooth scroll (no library). Buttons advance by one card-width + gap.
// Arrows auto-disable at scroll extremes.

class ProductRowSlider extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('.product-row__grid');
    this.prev = this.querySelector('.product-row__arrow--prev');
    this.next = this.querySelector('.product-row__arrow--next');
    if (!this.grid || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this._scroll(-1));
    this.next.addEventListener('click', () => this._scroll(1));

    this.grid.addEventListener('scroll', () => this._updateArrows());
    window.addEventListener('resize', () => this._updateArrows());

    // Initial arrow state (after layout)
    requestAnimationFrame(() => this._updateArrows());
  }

  _scroll(direction) {
    const firstCard = this.grid.firstElementChild;
    if (!firstCard) return;
    const cardWidth = firstCard.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.grid).columnGap || '24');
    const max = this.grid.scrollWidth - this.grid.clientWidth;
    if (max <= 1) return;
    const target = Math.max(0, Math.min(max, this.grid.scrollLeft + direction * (cardWidth + gap)));

    // iOS Safari reverts a programmatic smooth scroll while scroll-snap is
    // mandatory, so the snap is lifted for the length of the animation.
    this.grid.style.scrollSnapType = 'none';
    try {
      this.grid.scrollTo({ left: target, behavior: 'smooth' });
    } catch (err) {
      this.grid.scrollLeft = target;
    }
    clearTimeout(this._snapTimer);
    this._snapTimer = setTimeout(() => {
      this.grid.style.removeProperty('scroll-snap-type');
    }, 600);
  }

  _updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = this.grid;
    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
    this.prev.toggleAttribute('disabled', atStart);
    this.next.toggleAttribute('disabled', atEnd);
  }
}

customElements.define('product-row-slider', ProductRowSlider);

// --- "Best Sellers" ribbon lift ---
// The pink banner layer slides up into place when the section scrolls into view
// (and lifts a touch further on hover). The wordmark layer never moves.
(function initRibbonLift() {
  const ribbons = document.querySelectorAll('.product-row__ribbon');
  if (!ribbons.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  ribbons.forEach((ribbon) => ribbon.classList.add('is-ready'));

  if (!('IntersectionObserver' in window)) {
    ribbons.forEach((ribbon) => ribbon.classList.add('is-in-view'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.25 }
  );

  ribbons.forEach((ribbon) => observer.observe(ribbon));
})();
